<template>
  <div class="pt-2">
    <h5
      class="entreprise-siege-titre"
      :style="{ color: this.$themes.primary  }"
    >Collecteurs et droits</h5>
    <div class="row row-inside mt-2">
      <div class="flex md1 mr-1">
        <va-toggle small v-model="infosFormation.cma" label="CMA" />
      </div>
      <div class="flex md2">
        <va-select label="OPCO de l’entreprise" v-model="infosFormation.opco" :options="opco_list" />
      </div>
      <div class="flex md2 ml-2">
        <va-input
          disabled
          ref="inputNbEmployee"
          :value="value"
          label="Nombre d'employés siège"
          v-on:input="updateValue($event)"
        />
      </div>
    </div>
    <div class="row">
      <div class="flex md6 pa-3">
        <dashboard-comments-formation
          class="relance-container-list"
          ref="relancemng"
          :identreprise="identreprise"
          setheight="15"
        ></dashboard-comments-formation>
      </div>
      <div class="flex md6 pa-3">
        <dashboard-relances-formation
          class="relance-container-list"
          ref="relancemng"
          :identreprise="identreprise"
          setheight="18"
        ></dashboard-relances-formation>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, isEqual, find } from "lodash";
import DashboardCommentsFormation from "./DashboardCommentsFormation";
import DashboardRelancesFormation from "./DashboardRelancesFormation";

export default {
  name: "dashboardFormation",
  props: ["value", "identreprise"],
  components: { DashboardCommentsFormation, DashboardRelancesFormation },
  data() {
    return {
      infosUpdated: false,
      infosFormation: {
        cma: false,
        opco: ""
      },
      infosFormation_o: {
        cma: false,
        opco: ""
      },
      nbEmployeeProxy: "",
      opco_list: [
        "AFDAS",
        "ATLAS",
        "OCAPIAT",
        "Cohésion sociale",
        "Construction",
        "Opcommerce",
        "AKTO",
        "OPCO 2i",
        "Mobilités",
        "Entreprises de proximité",
        "Santé"
      ]
    };
  },
  mounted() {
    this.loadInfos();
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event);
    },
    async loadInfos() {
      try {
        let res = await axios.get("/api/formations/infos", {
          params: {
            identreprise: this.identreprise
          }
        });

        this.infosFormation.cma = res.data.cma ? true : false;
        this.infosFormation.opco = res.data.opco;
        this.infosFormation_o.cma = this.infosFormation.cma;
        this.infosFormation_o.opco = this.infosFormation.opco;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    infosFormation: {
      deep: true,
      handler() {
        if (!isEqual(this.infosFormation_o, this.infosFormation)) {
          this.$emit("infosChanged", true);
          this.infosUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infosUpdated = false;
        }
      }
    },
    identreprise(newvalue, oldvalue) {
      if (newvalue !== oldvalue) {
        //todo load data
      }
    }
  }
};
</script>

<style>
</style>
